import React from "react";
import {connect} from "react-redux";
import {
    getUrlAccessKey,
    getUrlGroupingId,
    getUrlDate,
} from "../../../../redux/selectors/navigation";
import {getFormattedArchiveLink} from "../../../../util/format";
import {navigateToNewsletterEdition} from "../../../../redux/actions/navigation";
import {getCurrentNewsletterEdition} from "../../../../redux/selectors/newsletters";

/**
 * format link to archived or temporary newsletter
 * @param {} props
 * @param {String} [props.temporaryId] Optional - NOTE! if you want to navigate to a temporary
 *        article you must pass this! We will NOT try to get the temporaryId from the URL as we
 *        cannot assume you want to stay in temporary land. If you don't pass it we will
 *        create a link to a non temp archive page with the other props given.
 * @return {}
 */
const ArchiveLink = (props) => {
    const {
        children,
        className,
        //date,
        groupingId,
        hash,
        temporaryId,
        title,
        outletName,
        formattedDate,
        urlAccessKey,
        urlGroupingId,
        //currentDataEdition,
    } = props;

    const url = getFormattedArchiveLink(
        urlAccessKey,
        groupingId || urlGroupingId,
        getDateForLink(props),
        hash,
        temporaryId
    );

    const onClick = event => {
        event.preventDefault();

        props.navigate({url, hash});
    }

    if (children) {
        return (
            <a href={url} className={className} onClick={onClick}>{children}</a>
        );
    } else {
        return (
            <a href={url} className={className} onClick={onClick}>
                <div className="nav-article">
                    {title}
                </div>

                <div className="nav-smaller">
                    <span className="nav-outlet text-truncate align-middle">{outletName}</span>

                    <span className="align-middle d-inline">&mdash;{formattedDate}</span>
                </div>
            </a>
        );
    }
};

const getDateForLink = ({date, currentDataEdition, urlDate}) => {
    if (date) {
        return date;
    } else if (currentDataEdition !== "") {
        return currentDataEdition;
    } else {
        return urlDate;
    }
};

/**
 * mapStateToProps returns the parts of the state that will be available as props
 * @param state
 * @returns {}
 */
const mapStateToProps = state => {
    return {
        urlAccessKey: getUrlAccessKey(state),
        urlGroupingId: getUrlGroupingId(state),
        currentDataEdition: getCurrentNewsletterEdition(state),
        urlDate: getUrlDate(state),
    };
};

/**
 * mapDispatchToProps exposes the actions we want to call as props
 * @param state
 * @returns {}
 */
const mapDispatchToProps = dispatch => {
    return {
        navigate: (params) => {
            dispatch(navigateToNewsletterEdition(params))
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ArchiveLink);
